import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { headerLinks } from '../../constants/headerLink';
import { HeaderLink } from './HeaderLink';
import { HamburgerIcon } from '@chakra-ui/icons';

export const HeaderMenuModal = () => {
  const { onClose, onOpen, isOpen } = useDisclosure();

  return (
    <>
      <HamburgerIcon onClick={onOpen} />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor={'bgColor.100'}
          border={'1px solid'}
          borderRadius={'12px'}
          borderColor={'borderGrey.100'}
          w={'fit-content'}
        >
          <ModalHeader fontWeight={400} fontSize={'18px'}>
            Links
          </ModalHeader>
          <ModalCloseButton mt={'3px'} />
          <ModalBody as={VStack} gap={'12px'} textAlign={'center'}>
            {headerLinks.map((link) => (
              <HeaderLink key={`${link.href}--${link.text}`} {...link} />
            ))}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
